<div style="width: 400px" *ngIf="type == 'Delete'">
  <h2 mat-dialog-title class="mb-0">
    {{ modalPopupText?.confirmation_title }}
  </h2>
  <mat-dialog-content class="mat-typography text-center">
    <p class="primary">{{ modalPopupText?.del_msg }}</p>
    <p>{{ modalPopupText?.cant_retrieve }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="my-3 d-flex justify-content-center">
      <button (click)="cancel()" mat-flat-button class="me-3">
        {{ buttonsText?.cancel_btn }}
      </button>
      <button (click)="done()" mat-flat-button color="primary">
        {{ buttonsText?.delete_btn }}
      </button>
    </div>
  </mat-dialog-actions>
</div>

<div *ngIf="type == 'Logout'">
  <div class="modal-dialog m-0 logout-width">
    <div class="modal-content">
      <app-modal-header-common [title]="modalPopupText?.confirmation_title"
        [dialogRef]="dialogRef"></app-modal-header-common>

      <div class="modal-body">
        <h5 class="py-3 text-center primary m-0">
          {{ modalPopupText?.logout_msg }}
        </h5>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-flat-button class="w-100 border bg-light">
              {{ buttonsText?.cancel_btn }}
            </button>
          </div>
          <div class="col-md-6">
            <button (click)="done()" mat-flat-button class="w-100" color="primary">
              {{ modalPopupText?.logout_btn }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'empty_goal'">
  <div class="modal-dialog m-0 logout-width">
    <div class="modal-content">
      <app-modal-header-common [title]="" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body" *ngIf="type.section == 'training'">
        <h5 class="py-3 text-center primary m-0">
          {{ modalPopupText?.training_empty_goal }}
        </h5>
      </div>
      <div class="modal-body" *ngIf="type.section == 'release_tracker'">
        <h5 class="py-3 text-center primary m-0">
          {{ modalPopupText?.release_tracker_empty_goal }}
        </h5>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-flat-button class="w-100 border bg-light">
              {{ buttonsText?.cancel_btn }}
            </button>
          </div>
          <div class="col-md-6">
            <button (click)="done()" mat-flat-button class="w-100" color="primary">
              {{ modalPopupText?.okay_btn }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type == 'Addopperuntiy'">
  <div class="modal-dialog m-0" style="max-width: 700px">
    <div class="modal-content" style="border: 0px">
      <app-modal-header-common [title]="'New Opportunity'" [dialogRef]="dialogRef">
      </app-modal-header-common>
      <div class="modal-body modal-oppz field-adjust opportunity-cls">
        <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>
          <mat-step>
            <ng-template matStepLabel>Create Opportunity</ng-template>
            <form [formGroup]="opportunityForm" class="mt-3">
              <div class="row">
                <div class="col-sm-12" *ngIf="data.name">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ data.disName }}</mat-label>
                    <input type="text" matInput fullWidth [maxlength]="maxChars" formControlName="name" required
                      id="input-0" />
                  </mat-form-field>
                </div>
                <div class="col-sm-6" *ngIf="data.opportunity">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ data.disOpportunity }}</mat-label>
                    <input matInput [matAutocomplete]="auto" type="text" formControlName="opportunity" required />
                    <mat-icon matSuffix class="muted">search</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filterOptionType | async" [value]="option">
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="
                        (submitted || f.opportunity.touched) &&
                        f.opportunity.errors
                      ">
                      <small class="text-danger" *ngIf="f.opportunity.errors.optionError">{{
                        commonText?.autocomplete_option_error }}</small>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6" *ngIf="data.portfolio">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ displayLabels.portfolio }}</mat-label>
                    <input matInput [matAutocomplete]="auto" type="text" formControlName="portfolio" required />
                    <mat-icon matSuffix class="muted">search</mat-icon>
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filterOptionPortfolio | async" [value]="option"
                        (onSelectionChange)="onSelectionChangePortfolio($event)">
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="
                        (submitted || f.portfolio.touched) && f.portfolio.errors
                      ">
                      <small class="text-danger" *ngIf="f.portfolio.errors.optionError">{{
                        commonText?.autocomplete_option_error }}</small>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6" *ngIf="data.subPortfolio">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ displayLabels.sub_portfolio }}</mat-label>
                    <input matInput [matAutocomplete]="auto1" type="text" formControlName="subPortfolio" required />
                    <mat-icon matSuffix class="muted">search</mat-icon>
                    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filterOptionSubPortfolio | async" [value]="option"
                        (onSelectionChange)="
                          onSelectionChangeSubportPortfolio($event)
                        ">
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="
                        (submitted || f.subPortfolio.touched) &&
                        f.subPortfolio.errors
                      ">
                      <small class="text-danger" *ngIf="f.subPortfolio.errors.optionError">{{
                        commonText?.autocomplete_option_error }}</small>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6" *ngIf="data.program">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ displayLabels.program }}</mat-label>
                    <input matInput [matAutocomplete]="auto5" type="text" formControlName="program" required />
                    <mat-icon matSuffix class="muted">search</mat-icon>
                    <mat-autocomplete #auto5="matAutocomplete" [displayWith]="displayFn">
                      <mat-option *ngFor="let option of filterOptionProgram | async" [value]="option">
                        {{ option.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="
                        (submitted || f.program.touched) && f.program.errors
                      ">
                      <small class="text-danger" *ngIf="f.program.errors.optionError">{{
                        commonText?.autocomplete_option_error }}</small>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-sm-6" *ngIf="data.owners">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{ data.disOwners }}</mat-label>
                    <input matInput type="text" readonly formControlName="owners" />
                  </mat-form-field>
                </div>
                <div class="col-sm-6"></div>
              </div>
            </form>
            <div class="d-flex align-items-center justify-content-end gap-2">
              <button (click)="cancel()" mat-button mat-dialog-close color="primary" class="mx-2">
                Close
              </button>
              <button mat-flat-button color="primary" matStepperNext [disabled]="opportunityForm.invalid">
                Next
              </button>
            </div>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup">
            <ng-template matStepLabel>Map Tag</ng-template>
            <div class="my-2 mb-4">
              <p style="font-size: 12px">
                <span *ngIf="opportunityForm?.value?.name">{{ opportunityForm?.value?.name }}
                </span>
                <span *ngIf="opportunityForm?.value?.opportunity?.name">&nbsp;| {{
                  opportunityForm?.value?.opportunity?.name }}</span>
                <span *ngIf="opportunityForm?.value?.portfolio?.name">&nbsp;| {{ opportunityForm?.value?.portfolio?.name
                  }}</span>
                <span *ngIf="opportunityForm?.value?.subPortfolio?.name">&nbsp;|
                  {{ opportunityForm?.value?.subPortfolio?.name }}</span>
                <span *ngIf="opportunityForm?.value?.program?.name">&nbsp;| {{ opportunityForm?.value?.program?.name
                  }}</span>
                <span *ngIf="ownerDetails?.first_name">&nbsp;|
                  {{
                  ownerDetails?.first_name + " " + ownerDetails?.last_name
                  }}</span>
              </p>
              <app-tag [noIds]="true" [tagsIds]="" (childTags)="getChildTags($event)"></app-tag>
            </div>
            <div style="display: flex; justify-content: end">
              <button mat-button matStepperPrevious>Back</button>

              <button (click)="cancel()" mat-button mat-dialog-close color="primary" class="mx-2">
                Close
              </button>
              <button (click)="add()" color="primary" status="primary" mat-button mat-flat-button>
                Create Opportunity
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type == 'AddProject'">
  <div class="modal-dialog m-0" style="max-width: 900px">
    <div class="modal-content dialog-wrapper" style="border: 0px">
      <app-modal-header-common [title]="'New ' + (displayLabels?.project | titlecase)" [dialogRef]="dialogRef">
      </app-modal-header-common>
      <div class="dialog-content modal-oppz field-adjust projectCreate">
        <mat-stepper orientation="vertical" [linear]="isLinear" #stepper>
          <mat-step>
            <ng-template matStepLabel>Create {{ displayLabels?.project | titlecase }}</ng-template>
            <form [formGroup]="projectForm" class="mt-3 project-details-form">
              <div class="row">
                <mat-form-field appearance="outline" class="w-50 pe-1" *ngIf="data.portfolio">
                  <mat-label>{{ displayLabels?.portfolio }}</mat-label>
                  <input matInput [matAutocomplete]="auto" type="text" formControlName="portfolio_id" required />
                  <mat-icon matSuffix class="muted">search</mat-icon>
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filterOptionPortfolio | async" [value]="option"
                      (onSelectionChange)="
                          onSelectionChangePortfolioProject($event)
                        ">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-50 ps-1" *ngIf="data.subPortfolio">
                  <mat-label>{{ displayLabels?.sub_portfolio }}</mat-label>
                  <input matInput [matAutocomplete]="auto1" type="text" formControlName="subportfolio_id" required />
                  <mat-icon matSuffix class="muted">search</mat-icon>
                  <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filterOptionSubPortfolio | async" [value]="option"
                      (onSelectionChange)="
                          onSelectionChangeSubportPortfolioProject($event)
                        ">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-50 pe-1" *ngIf="data.program">
                  <mat-label>{{ displayLabels.program }}</mat-label>
                  <input matInput [matAutocomplete]="program" type="text" formControlName="program_id" required />
                  <mat-icon matSuffix class="muted">search</mat-icon>
                  <mat-autocomplete #program="matAutocomplete" [displayWith]="displayFn">
                    <mat-option *ngFor="let option of filterOptionProgram | async" [value]="option" (onSelectionChange)="
                          onSelectionChangeProgramProject($event)
                        ">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
                <app-searchable-dropdown class="w-50 ps-1" formControlName="owner_id"
                  [labelText]="((displayLabels?.project | titlecase) || '') + ' Owner'" [options]="ownerOptions"
                  [valueKey]="'id'" [displayWith]="displayFnOwner"
                  [searchKeys]="['first_name', 'last_name', 'email']">
                </app-searchable-dropdown>
                <div class="col-md-12">
                  <mat-form-field appearance="outline" class="w-50 pe-1">
                    <mat-label>{{ displayLabels?.project | titlecase }} Name</mat-label>
                    <input type="text" matInput formControlName="project_name" required />
                  </mat-form-field>
                  <app-searchable-dropdown class="w-50 ps-1" formControlName="project_type_id"
                    [labelText]="((displayLabels?.project | titlecase) || '') + ' Type'" [options]="projectType"
                    [valueKey]="'id'">
                  </app-searchable-dropdown>
                  <mat-form-field appearance="outline" class="w-25 pe-1">
                    <mat-label>{{
                      displayLabels?.project | titlecase
                      }}
                      Number</mat-label>
                    <input type="text" matInput formControlName="project_id" required
                      [placeholder]="projectNumberControl?.disabled ? 'Select hierarchy first' : ''" />
                    <mat-icon matSuffix
                      style="color: #333333; font-size: 16px; width: 16px; height: 16px; line-height: 16px; cursor: pointer;"
                      *ngIf="projectNumberControl?.disabled"
                      [matTooltip]="'Select ' + (displayLabels?.portfolio | lowercase) + ', ' + (displayLabels?.sub_portfolio | lowercase) + ' and ' + (displayLabels?.program | lowercase)">info_outline</mat-icon>
                    <mat-icon matSuffix class="text-success"
                      style="font-size: 16px; width: 16px; height: 16px; line-height: 16px; cursor: pointer;"
                      *ngIf="projectNumberStatus === 'available' && !projectNumberControl?.hasError('projectNumberExists')"
                      [matTooltip]="'This ' + (displayLabels?.project | lowercase) + ' number is available'">check_circle</mat-icon>
                    <mat-icon matSuffix class="text-danger"
                      style="font-size: 16px; width: 16px; height: 16px; line-height: 16px; cursor: pointer;"
                      *ngIf="projectNumberControl?.hasError('projectNumberExists')"
                      [matTooltip]="'This ' + (displayLabels?.project | lowercase) + ' number is already taken.'">cancel</mat-icon>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-25 ps-1 pe-1">
                    <mat-icon matPrefix>attach_money</mat-icon>
                    <mat-label>{{ displayLabels?.project | titlecase }} Value</mat-label>
                    <input type="text" matInput formControlName="project_value" required />
                  </mat-form-field>
                  <app-searchable-dropdown class="w-50 ps-1" formControlName="project_funding_type_id"
                    [labelText]="((displayLabels?.project | titlecase) || '') + ' Funding Type'" [options]="projectFundingType"
                    [valueKey]="'id'">
                  </app-searchable-dropdown>
                  <mat-form-field appearance="outline" class="w-50 pe-1">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="startDate" (focus)="startDate.open()" readonly
                      formControlName="begin_date" required />
                    <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                    <mat-datepicker #startDate></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-50 ps-1">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="endDate" (focus)="endDate.open()" readonly
                      formControlName="expected_end_date" required />
                    <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                    <mat-datepicker #endDate></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup">
            <ng-template matStepLabel>Map Tags</ng-template>
            <div class="my-2 mb-4">
              <p style="font-size: 12px">
                <span *ngIf="projectForm?.value?.project_name">{{
                  projectForm?.value?.project_name
                  }}</span>
                <span *ngIf="projectForm?.value?.project_id">&nbsp;| {{ projectForm?.value?.project_id }}</span>
                <span *ngIf="projectForm?.value?.project_value">&nbsp;| {{ projectForm?.value?.project_value }}</span>
                <span *ngIf="projectForm?.value?.portfolio_id?.name">&nbsp;| {{ projectForm?.value?.portfolio_id?.name
                  }}</span>
                <span *ngIf="projectForm?.value?.subportfolio_id?.name">&nbsp;| {{
                  projectForm?.value?.subportfolio_id?.name }}</span>
                <span *ngIf="projectForm?.value?.program_id?.name">&nbsp;| {{ projectForm?.value?.program_id?.name
                  }}</span>
              </p>
              <app-tag [noIds]="true" [tagsIds]="" (childTags)="getChildProjectTags($event)"></app-tag>
            </div>
          </mat-step>
          <mat-step [stepControl]="menuFormArray">
            <ng-template matStepLabel> Menu Selection </ng-template>
            <div class="d-flex justify-content-end my-2" *ngIf="projectMenuCategories?.length">
              <div class="menu-landing-legend">
                <mat-icon class="legend-icon">home</mat-icon>
                <span>Default Landing Page</span>
              </div>
            </div>
            <form [formGroup]="projectForm" *ngIf="projectMenuCategories?.length" style="
                height: 55vh;
                overflow-y: auto;">
              <div style="margin-top: 8px" formArrayName="menu">
                <ng-container *ngFor="let category of projectMenuCategories; let i = index">
                  <!-- CATEGORY HEADER (for non-null categories) -->
                  <div *ngIf="category.category_id" class="category-block">
                    <div class="accordion-header">
                      <input type="checkbox" [checked]="isCategoryAllSelected(category)"
                        [disabled]="isCategoryLocked(category)"
                        (change)="toggleCategorySelection(category)" (click)="$event.stopPropagation()" />
                      <span class="log-number ms-2">{{ i + 1 }}</span>
                      <span class="title ms-2" style="font-size: 14px; font-weight: 500"
                        (click)="toggleMenuCategory(category)" style="cursor: pointer; flex: 1">
                        {{ category.category_display_name }}
                      </span>
                      <mat-icon class="ms-auto" (click)="toggleMenuCategory(category)" style="cursor: pointer">
                        {{
                        category.expanded
                        ? "keyboard_arrow_up"
                        : "keyboard_arrow_down"
                        }}
                      </mat-icon>
                    </div>
                  </div>

                  <!-- MENU ITEMS -->
                  <div *ngIf="category.expanded || !category.category_id">
                    <ng-container *ngFor="let menu of category.menus; let j = index">
                      <div class="menu-row" [class.root-menu]="!category.category_id"
                        [class.locked]="menu.locked"
                        [formGroup]="getMenuFormGroup(menu.id)">
                        <input type="checkbox" formControlName="selected" (change)="toggleRisk(null)" />
                        <span class="log-number ms-2">{{ j + 1 }}</span>
                        <span class="menu-name ms-2">{{
                          menu.display_name
                          }}</span>
                        <mat-icon *ngIf="menu.locked" class="lock-icon ms-2"
                          matTooltip="Not included in your licence">lock</mat-icon>
                        <mat-icon class="home-menu-icon ms-2" *ngIf="getMenuFormGroup(menu.id)?.value?.selected" [class.selected]="isHomePageMenu(menu.id)" (click)="
                            $event.stopPropagation(); setHomePageMenu(menu.id)
                          ">
                          home
                        </mat-icon>
                        <small class="menu-description ms-auto" [matTooltip]="menu.description">{{ menu.description
                          }}</small>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </form>
          </mat-step>
        </mat-stepper>
      </div>
      <div class="modal-footer" style="display: flex; justify-content: end">
        <button *ngIf="stepper?.selectedIndex > 0" mat-button (click)="stepper.previous()">
          Back
        </button>
        <button (click)="cancel()" mat-button mat-dialog-close color="primary" class="mx-2">
          Close
        </button>
        <button *ngIf="stepper?.selectedIndex < 2" mat-flat-button mat-button color="primary" (click)="stepper.next()"
          [disabled]="projectForm.invalid">
          Next
        </button>
        <button *ngIf="stepper?.selectedIndex === 2" (click)="addProject()" color="primary" status="primary" mat-button
          mat-flat-button [disabled]="projectForm.invalid">
          Create {{ displayLabels?.project | titlecase }}
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'evaluation_empty'">
  <div class="modal-dialog m-0 logout-width">
    <div class="modal-content">
      <app-modal-header-common [title]="" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body">
        <h5 class="py-3 text-center primary m-0">
          {{ modalPopupText?.evaluation_empty_scope }}
        </h5>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="done()" mat-flat-button color="primary">
              {{ modalPopupText?.okay_btn }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section class="balancequadrant" *ngIf="type == 'balancequadrant'">
  <div class="container-fluid customwidth">
    <div class="modal-dialog m-0 logout-width">
      <div class="modal-content">
        <app-modal-header-common [title]="'Customer chart view'" [dialogRef]="dialogRef">
        </app-modal-header-common>

        <div class="modal-body">
          <h5 class="py-3 text-center primary m-0">
            Are you sure you want to logout?
          </h5>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-md-6">
              <button (click)="cancel()" mat-flat-button class="w-100 border bg-light">
                Cancel
              </button>
            </div>
            <div class="col-md-6">
              <button (click)="done()" mat-flat-button class="w-100" color="primary">
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div *ngIf="type == 'ArchiveList'">
  <div class="modal-dialog m-0 logout-width">
    <div class="modal-content">
      <app-modal-header-common [title]="'Archive List'" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body">
        <div class="table-container">
          <table>
            <thead style="position: sticky; top: 0; z-index: 1">
              <tr>
                <th class="fixed-header text-center" scope="col">#</th>
                <th class="fixed-header text-center w-75" scope="col">
                  {{ typeName }}
                </th>
                <th class="fixed-header text-center" scope="col">Select</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let option of archiveList; let i = index">
                <td class="highlighted" style="font-style: italic">
                  {{ i + 1 }}
                </td>
                <td class="align-middle highlighted w-75">
                  <span style="font-size: 1em">{{
                    option.opportunity_name || option.project_name
                    }}</span>
                  <span style="font-size: 0.8em; display: block">{{
                    option.opportunity_number || option.project_id
                    }}</span>
                </td>
                <td class="align-middle">
                  <input #checkboxes type="checkbox" [checked]="option.selected"
                    (change)="option.selected = !option.selected" (click)="$event.stopPropagation()" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-end gap-2" style="flex-shrink: 0">
        <button (click)="cancel()" mat-button mat-dialog-close color="secondary">
          Close
        </button>
        <button (click)="done()" mat-flat-button mat-button color="primary">
          Unarchive
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'user_owner'">
  <div class="modal-dialog m-0 logout-width">
    <div class="modal-content">
      <app-modal-header-common [title]="type?.header_name" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body" *ngIf="type.team_list">
        <input type="text" placeholder="Search user" class="form-control mb-2" [(ngModel)]="userSearchText" />
        <div style="height: 30vh; overflow-y: scroll">
          <div *ngFor="let team of type.team_list; let i = index">
            <div class="mt-2" style="display: flex; font-size: 12px" [hidden]="!searchUser(team, userSearchText)">
              <input type="checkbox" id="sqw{{ i }}" name="sqw{{ i }}" [(ngModel)]="team.selected"
                [disabled]="!type.allowed" />
              <label for="sqw{{ i }}"> {{ team.name }}</label><br />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-flat-button color="secondary">
              Close
            </button>
          </div>
          <div class="col-md-6" *ngIf="type.allowed">
            <button (click)="done()" mat-flat-button color="primary">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'map_sow_to_project'">
  <div class="modal-dialog m-0" style="max-width: 800px; overflow: hidden">
    <div class="modal-content">
      <app-modal-header-common [title]="'Map Contracts'" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="scrollable-area" *ngIf="type.contract_List">
        <input type="text" placeholder="Search SOW" class="form-control mb-2" [(ngModel)]="contractSearchText" />

        <div style="height: calc(100vh - 320px); overflow-y: scroll">
          <div *ngFor="let contract of type.contract_List; let i = index">
            <div class="mt-2" style="display: flex; font-size: 12px"
              [hidden]="!searchContract(contract, contractSearchText)">
              <input type="checkbox" id="cont{{ i }}" [(ngModel)]="contract.selected"
                (ngModelChange)="getResourceListFromContract(i, $event)" />
              <label for="cont{{ i }}">{{ contract.contract_name }}</label>
            </div>

            <span *ngIf="contract?.resourseList?.length > 0" class="ms-4" style="font-size: 12px">
              Select Resource
            </span>

            <div *ngFor="let resource of contract.resourseList; let j = index" class="ms-4">
              <div class="mt-2" style="display: flex; font-size: 12px">
                <input type="checkbox" id="res{{ i }}{{ j }}" [(ngModel)]="resource.selected"
                  (ngModelChange)="selectedResource(resource, i, $event)" />
                <label for="res{{ i }}{{ j }}">{{
                  resource.resource_name
                  }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-button color="primary">Close</button>
          </div>
          <div class="col-md-6">
            <button (click)="done()" mat-flat-button color="primary" class="bg-primary text-white">
              Map
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'surveyComments'">
  <div class="modal-dialog m-0 logout-width" style="max-width: 600px !important; max-height: 450px !important">
    <div class="modal-content">
      <app-modal-header-common [title]="'Comments'" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body" style="max-height: 300px !important; overflow: auto">
        <div class="mb-2" *ngFor="let comments of surveyComments">
          <h6 id="{{ comments?.id }}">{{ comments?.display_text }}</h6>
          <div class="mt-2 custom-table fixed-table-header">
            <table class="table table-bordered">
              <tr>
                <ng-container *ngFor="let option of comments.options">
                  <td class="p-0">
              <tr>
                <th style="
                          font-size: 0.8rem !important;
                          padding: 4px;
                          text-align: center;
                        ">
                  {{ option.display_text }}
                </th>
              </tr>
              <tr *ngFor="let comment of option.comments">
                <td style="font-size: 12px !important; padding: 4px">
                  {{ comment.answer_text }}
                </td>
              </tr>
              </td>
              </ng-container>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-flat-button color="secondary">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="type.name == 'CreatePlan'">
  <div class="modal-dialog m-0 logout-width" style="max-width: 600px !important; max-height: 450px !important">
    <div class="modal-content">
      <app-modal-header-common [title]="'Create Plan'" [dialogRef]="dialogRef">
      </app-modal-header-common>
      <div class="modal-body" style="max-height: 300px !important; overflow: auto">
        <mat-form-field appearance="legacy" class="w-100">
          <mat-label class="label-design">Plan Name</mat-label>
          <input type="text" matInput fullWidth formControlName="plan_name" />
        </mat-form-field>
        <mat-form-field class="example-full-width" style="width: 100%" appearance="outline" formGroupName="owner">
          <mat-chip-list #chipList1 aria-label="owner selection">
            <mat-chip *ngFor="let item of filterForm?.value.owner.array" [selectable]="selectable"
              (removed)="remove(item, 'owner')">
              {{ item.display_name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input placeholder="Search owner..." formControlName="input" [matAutocomplete]="auto"
              [matChipInputFor]="chipList1" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur" name="owner_name" />
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="search($event, 'owner')">
            <mat-option *ngFor="let option of filteredList(filteredOwnerList, 'owner')" [value]="option"
              style="font-size: 0.8rem; height: 30px">
              {{ option.display_name }}
            </mat-option>
          </mat-autocomplete>
          <button mat-button mat-icon-button matSuffix class="close-btn" (click)="clearSearchField('owner')"
            *ngIf="filterForm.value.owner.array.length > 0">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field appearance="legacy" class="w-50">
          <mat-label class="label-design">Start Date</mat-label>
          <input matInput [matDatepicker]="startDate" (focus)="startDate.open()" readonly
            formControlName="start_date" />
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="legacy" class="w-50">
          <mat-label class="label-design">End Date</mat-label>
          <input matInput [matDatepicker]="endDate" (focus)="endDate.open()" readonly formControlName="end_date" />
          <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
          <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-flat-button color="secondary">
              Close
            </button>
          </div>
          <div class="col-md-6">
            <button (click)="done()" mat-flat-button color="primary">
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'projectpop'">
  <div class="modal-dialog m-0 logout-width"
    style="max-width: 80vw !important; height: 90vh !important; overflow: auto">
    <div class="modal-content" style="height: 100%" *ngIf="iframeUrl">
      <app-loading *ngIf="!iframeLoaded && !iframeLoadingError"></app-loading>
      <div *ngIf="iframeLoaded" class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeUrl" id="emberIfram" style="height: 100vh !important"
        title="(displayLabels?.project | titlecase) + 'Info'"></iframe>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'projectokr'">
  <div class="modal-dialog m-0 logout-width"
    style="max-width: 80vw !important; height: 90vh !important; overflow: auto">
    <div class="modal-content" style="height: 100%" *ngIf="iframeUrl">
      <app-loading *ngIf="!iframeLoaded && !iframeLoadingError"></app-loading>
      <div *ngIf="iframeLoaded" class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeUrl" id="emberIfram" style="height: 100vh !important"
        title="(displayLabels?.project | titlecase) + 'OKR'"></iframe>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'projectrisk'">
  <div class="modal-dialog m-0 logout-width"
    style="max-width: 80vw !important; height: 90vh !important; overflow: auto">
    <div class="modal-content" style="height: 100%" *ngIf="iframeUrl">
      <app-loading *ngIf="!iframeLoaded && !iframeLoadingError"></app-loading>
      <div *ngIf="iframeLoaded" class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeUrl" id="emberIfram" style="height: 100vh !important"
        title="(displayLabels?.project | titlecase) + 'Risk'"></iframe>
    </div>
  </div>
</div>

<div *ngIf="type.name == 'assessmentpop'">
  <div class="modal-dialog m-0 logout-width" style="
      max-width: 80vw !important;
      height: 80vh !important;
      overflow: hidden;
    ">
    <div class="modal-content" *ngIf="iframeUrl">
      <app-loading *ngIf="!iframeLoaded && !iframeLoadingError"></app-loading>
      <div *ngIf="iframeLoaded" class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeUrl" id="emberIfram" style="height: 80vh !important" title="Assessment Info"
        scrolling="no"></iframe>
    </div>
  </div>
</div>
<div *ngIf="type.name == 'instancepop'">
  <div class="modal-dialog m-0 logout-width" style="
      max-width: 80vw !important;
      height: 80vh !important;
      overflow: hidden;
    ">
    <div class="modal-content" *ngIf="iframeInstanceUrl">
      <app-loading *ngIf="!iframeLoaded && !iframeLoadingError"></app-loading>
      <div *ngIf="iframeLoaded" class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeInstanceUrl" id="emberIfram" style="height: 80vh !important" title="Instance Info"></iframe>
    </div>
  </div>
</div>
<div *ngIf="type.name == 'opportunitypop'">
  <div class="modal-dialog m-0 logout-width"
    style="max-width: 80vw !important; height: 90vh !important; overflow: auto">
    <div class="modal-content" style="height: 100%" *ngIf="iframeUrl">
      <div class="open-icon" (click)="close()">
        <mat-icon>close</mat-icon>
      </div>
      <iframe [src]="iframeUrl" *ngIf="iframeUrl" id="emberIframId" style="height: 100vh !important"
        title="Opportunity Info"></iframe>
    </div>
  </div>
</div>
<div *ngIf="type == 'ShowInvestment'">
  <div class="modal-dialog m-0 logout-width" style="max-width: 700px !important; max-height: 450px !important">
    <div class="modal-content">
      <app-modal-header-common [title]="'Investment History'" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body" style="max-height: 300px !important; overflow: auto">
        <div class="mt-2 table-container fixed-table-header">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="text-center">Description</th>
                <th class="text-center">Commitment</th>
                <th class="text-center">Consumed Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of modalData">
                <td>
                  {{ data.description }}
                </td>
                <td>
                  {{ data.amount | appFormat: "currency" }}
                </td>
                <td>
                  {{ getConsumed(data.blended_costs) | appFormat: "currency" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-6">
            <button (click)="cancel()" mat-button color="secondary">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<section *ngIf="type == 'activate_control_confirmation'">
  <div class="modal-dialog m-0">
    <div class="modal-content">
      <app-modal-header-common [title]="modalData?.title" [dialogRef]="dialogRef">
      </app-modal-header-common>

      <div class="modal-body" style="padding-bottom: 0px">
        <p [innerHTML]="modalData?.message" style="text-align: center"></p>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-end gap-2">
          <button mat-button (click)="cancel()">
            {{ modalData?.negative_btn }}
          </button>

          <button mat-flat-button color="primary" (click)="done()">
            {{ modalData?.positive_btn }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>